import { theme } from '@theme';
import { DealStatus } from '../enums/DealStatus';

export const useDealStatus = (): StatusReturnType => {
  const colorStatusMap = new Map();
  colorStatusMap.set(DealStatus.NotContacted.valueOf(), {
    color: theme.palette.purple,
  });
  colorStatusMap.set(DealStatus.Attempted.valueOf(), {
    color: theme.palette.dusty,
  });
  colorStatusMap.set(DealStatus.Contacted.valueOf(), {
    color: theme.palette.blue,
  });
  colorStatusMap.set(DealStatus.Appointment.valueOf(), {
    color: theme.palette.yellow,
  });
  colorStatusMap.set(DealStatus.Negotiating.valueOf(), {
    color: theme.palette.orangeWarning,
  });
  colorStatusMap.set(DealStatus.Sold.valueOf(), { color: theme.palette.green });
  colorStatusMap.set(DealStatus.LostDeal.valueOf(), {
    color: theme.palette.equifaxRed,
  });

  const getColor = (status: string): string => {
    return colorStatusMap.get(status)?.color || theme.palette.black;
  };

  const getFilterCountColor = (status: string): string => {
    return colorStatusMap.get(status) ? theme.palette.white : theme.palette.dusty;
  };

  const getFilterCountBackgroundColor = (status: string): string => {
    return colorStatusMap.get(status)?.color || theme.palette.lightGray;
  };

  return { getColor, getFilterCountColor, getFilterCountBackgroundColor };
};

type StatusReturnType = {
  getColor(status: string): string;
  getFilterCountColor(status: string): string;
  getFilterCountBackgroundColor(status: string): string;
};
